import { render, staticRenderFns } from "./informationDetail.vue?vue&type=template&id=d4a1df64&scoped=true"
import script from "./informationDetail.vue?vue&type=script&lang=js"
export * from "./informationDetail.vue?vue&type=script&lang=js"
import style0 from "./informationDetail.vue?vue&type=style&index=0&id=d4a1df64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a1df64",
  null
  
)

export default component.exports